import { module } from 'modujs';
import Mustache from 'mustache';
import * as focusTrap from 'focus-trap';

const template = `
    <div class="c-team-modal_title || c-heading -h1">
        {{fancy-name}}
    </div>

    <div class="c-team-modal_infos">
        <dl class="c-team-modal_specs">
            {{# hasProjects }}
            <dt>{{ labels.projects }}</dt>
            <dd>
                <ul>
                    {{# projects }}
                    <li><a href="{{ url }}">{{ title }}</a></li>
                    {{/ projects }}
                </ul>
            </dd>
            {{/ hasProjects }}
            <dt>{{ labels.role }}</dt>
            <dd>{{ position }}</dd>
            <dt>{{ labels.since }}</dt>
            <dd>{{ arrival-year }}</dd>
        </dl>
    </div>
`

export default class extends module {
    constructor(m) {
        super(m);

        this.$infos = this.$('infos')[0]
        this.$canvas = this.$('canvas')[0]
        this.$dropdown = this.$('dropdown')[0]
        this.$dropdownLabel = this.$('dropdown-label')[0]
        this.members = Array.from(this.$('member'))
        this.labels = {
            'role': this.getData('role-label'),
            'since': this.getData('since-label'),
            'projects': this.getData('projects-label'),
        }

        this.events = {
            click: {
                'member': 'setMemberByEl',
                'close': 'hide'
            },
            change: {
                'dropdown': 'setMemberByDropdown'
            }
        }
    }

    init() {
        this.usdzReadyBind = (e) => {
            if(!this.quickLookBtn) {
                this.quickLookBtn = document.createElement("a");
                this.quickLookBtn.rel = 'ar'
                this.quickLookBtn.download = "asset.usdz"
                this.quickLookBtn.classList.add('c-team-modal_ar-btn')
                this.quickLookBtn.innerHTML = `<img src="https://threejs.org/examples/files/arkit.png">`
                this.el.appendChild(this.quickLookBtn)
            }
            this.quickLookBtn.style.display = '';
            this.quickLookBtn.href = e.detail.usdz
        }
        this.hideUsdz = () => {
            if(this.quickLookBtn) this.quickLookBtn.style.display = 'none';
        }
        this.$canvas.addEventListener('usdzReady', this.usdzReadyBind)
        this.$canvas.addEventListener('hideUsdz', this.hideUsdz)

        window.addEventListener('keydown', this.onKeyDown = e => {
            // Escape key
            if(e.keyCode === 27 && this.el.classList.contains('-active')) {
                this.hide()
            }
        })

        this.focusTrap = focusTrap.createFocusTrap(this.el);
    }

    show(memberInfos) {
        memberInfos && this.setMember(memberInfos);

        this.el.classList.add('-active')
        this.call('resize', null, 'TeamModalCanvas')

        this.focusTrap.activate()

        if(window.gtag) {
            gtag("event", "click", {
                "event_category": "team_modal",
                "event_label": "open"
            });
        }
    }

    hide() {
        this.updateUrl(false);

        this.el.classList.remove('-active')
        this.focusTrap.deactivate()

        this.call('setModel', false, 'TeamModalCanvas')
        this.call('setDefaultAnimation', false, 'TeamModalCanvas')
    }

    updateUrl(id) {
        const newURL = new URL(window.location.href)

        if(id)
            newURL.searchParams.set('teamMember', id);
        else {
            newURL.searchParams.delete('teamMember');
            newURL.searchParams.delete('anim');
        }

        // Replace the current URL without triggering a page change
        history.replaceState(
            null,
            null,
            newURL.toString()
        );
    }

    setMember(infos) {
        this.updateUrl(infos.id);

        if(!infos['fancy-name']) infos['fancy-name'] = infos.name;
        infos['hasProjects'] = infos['projects'] && infos['projects'].length > 0;
        infos['labels'] = this.labels

        this.$infos.innerHTML = Mustache.render(template, infos);
        this.$dropdown.value = infos.id;
        this.$dropdownLabel.innerText = infos['fancy-name'] || infos['name']

        let oldMember = this.members.find(item => item.classList.contains('-active'))
        oldMember && oldMember.classList.remove('-active');
        let newMember = this.members.find(item => item.dataset.teamModalId == infos.id)
        newMember && newMember.classList.add('-active')

        this.call('setModel', infos.model, 'TeamModalCanvas')
    }

    setMemberByEl(e) {
        const infos = JSON.parse(this.getData('infos', e.currentTarget));
        this.setMember(infos);
    }

    setMemberByDropdown(e) {
        let dropdown = e.curTarget;
        this.setMember(JSON.parse(dropdown.options[dropdown.selectedIndex].dataset.teamModalInfos));
    }

    destroy() {
        super.destroy()

        this.$canvas.removeEventListener('usdzReady', this.usdzReadyBind)
        this.$canvas.removeEventListener('hideUsdz', this.hideUsdz)
        this.focusTrap.deactivate()
    }
}
